export function normalizeWebpProfiles(profiles)
{
	if (!Array.isArray(profiles))
		return [];

	return profiles
		.filter((profile) => profile && typeof profile === "object")
		.map((profile) =>
		{
			const canvas = profile.canvas && typeof profile.canvas === "object"
				? profile.canvas
				: {};

			return {
				...profile,
				canvas: {
					enabled: canvas.enabled === true,
					width: typeof canvas.width === "number" ? canvas.width : 1024,
					height: typeof canvas.height === "number" ? canvas.height : 1024,
					fillPercentage: typeof canvas.fillPercentage === "number"
						? Math.min(Math.max(Math.round(canvas.fillPercentage), 1), 100)
						: 100
				},
				transparency: profile.transparency !== false,
				backgroundColor: typeof profile.backgroundColor === "string" ? profile.backgroundColor : "#FFFFFF",
				quality: typeof profile.quality === "number" ? profile.quality : 80,
				isDefault: profile.isDefault === true
			};
		});
}
